import React, { forwardRef, useImperativeHandle } from 'react';

import * as General from '../General/General';
import * as rsuite from 'rsuite';
import { trackPromise } from 'react-promise-tracker';


const GetTax = forwardRef((props, ref) => {


    useImperativeHandle(ref, () => ({

        Get() {
            trackPromise(
                fetch(General.ApiRoute() + '/Common/GetTax', {
                    method: 'Get',
                    headers: {
                        'ApiKey': General.APIKey()
                    },
                    credentials: 'include'
                })
                    .then(res => res.json())
                    .then(result => {
                        props.onSubmit(result);
                    })
            )

        },
    }),
        [props.value])

    return (
        <></>
    )
});

export default GetTax;